var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "social_links",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;enable-background:new    ;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "container",
    className: "st0",
    cx: 20,
    cy: 20,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube",
    className: "st1",
    d: "M29,16.3c-0.3-2.1-1.4-2.5-3.5-2.7c-1.8-0.1-3.9-0.2-5.5-0.2s-3.7,0.1-5.5,0.2 c-2.1,0.2-3.2,0.5-3.5,2.7c-0.1,1-0.2,2.3-0.2,3.7c0,1.4,0.1,2.7,0.2,3.7c0.3,2.2,1.4,2.5,3.5,2.7c1.8,0.2,3.9,0.2,5.5,0.2 s3.7,0,5.5-0.2c2.1-0.2,3.2-0.5,3.5-2.7c0.1-0.9,0.2-2.3,0.2-3.7C29.3,18.6,29.2,17.3,29,16.3z M18.2,22.8v-5.6L23,20L18.2,22.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social-youtube.0bb807345e20cf74e61e7c58191c5ec5.svg";
export { ForwardRef as ReactComponent };